import React from "react";

function Footer() {
  return (
    <footer className="mastfoot mt-5">
      <div className="container justify-content-center py-2 mb-4 border-top"></div>
      <p className="text-muted">
        © 2022 Copyright - Iron Plants - Made By Daiane Reina
      </p>
    </footer>
  );
}

export default Footer;
